import { PostHogProvider as PostHogProviderBase } from 'posthog-js/react';
import React from 'react';

import { config } from '~/config';

export const PostHogProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  if (['staging', 'prod'].includes(config.app.environment)) {
    return (
      <PostHogProviderBase
        apiKey={config.posthog.apiKey}
        options={{
          api_host: config.posthog.apiHost,
          opt_in_site_apps: true,
          ui_host: config.posthog.uiHost,
          defaults: '2025-05-24',
          capture_exceptions: false,
          debug: false,
          session_recording: {
            maskTextSelector: '.email-address',
          },
          custom_blocked_useragents: ['GrafanaSyntheticMonitoring'],
        }}
      >
        {children}
      </PostHogProviderBase>
    );
  }

  return <>{children}</>;
};
